export const queryKeys = {
  health: ["health"] as const,
  companies: {
    all: ["companies"] as const,
    detail: (id: string) => ["companies", id] as const,
  },
  agents: {
    byCompany: (companyId: string) => ["agents", "company", companyId] as const,
    detail: (id: string) => ["agents", "detail", id] as const,
  },
  issues: {
    byCompany: (companyId: string) => ["issues", "company", companyId] as const,
    detail: (id: string) => ["issues", "detail", id] as const,
  },
  projects: {
    byCompany: (companyId: string) => ["projects", "company", companyId] as const,
  },
  goals: {
    byCompany: (companyId: string) => ["goals", "company", companyId] as const,
    detail: (id: string) => ["goals", "detail", id] as const,
    progress: (id: string) => ["goals", "progress", id] as const,
    messages: (goalId: string) => ["goals", "messages", goalId] as const,
    unreadCount: (companyId: string) => ["goals", "unread", companyId] as const,
  },
  approvals: {
    byCompany: (companyId: string) => ["approvals", "company", companyId] as const,
  },
  mcpCatalogue: {
    all: ["mcp-catalogue"] as const,
    // Scoped listings — e.g. for a tenant's view which receives platform +
    // its own MCPs; also for the admin filter dropdown. `null` means
    // "platform only".
    filtered: (filter: string | null | undefined) => ["mcp-catalogue", "filter", filter ?? "all"] as const,
  },
  skillCatalogue: {
    all: ["skill-catalogue"] as const,
  },
  tenantMcps: {
    byCompany: (companyId: string) => ["tenant-mcps", companyId] as const,
  },
  tenantSkills: {
    byCompany: (companyId: string) => ["tenant-skills", companyId] as const,
  },
  agentMcps: {
    byAgent: (agentId: string) => ["agent-mcps", agentId] as const,
  },
  agentSkills: {
    byAgent: (agentId: string) => ["agent-skills", agentId] as const,
  },
  agentKeys: {
    byAgent: (agentId: string) => ["agent-keys", agentId] as const,
  },
  deployments: {
    byCompany: (companyId: string) => ["deployments", companyId] as const,
    detail: (id: string) => ["deployments", "detail", id] as const,
  },
  hiring: {
    byCompany: (companyId: string) => ["hiring", "company", companyId] as const,
    detail: (id: string) => ["hiring", "detail", id] as const,
  },
  notifications: {
    byCompany: (companyId: string) => ["notifications", "company", companyId] as const,
  },
  artifacts: {
    byCompany: (companyId: string) => ["artifacts", "company", companyId] as const,
  },
  m365: {
    byCompany: (companyId: string) => ["m365", companyId] as const,
  },
  models: {
    all: ["models"] as const,
  },
  tenantUsers: {
    byCompany: (companyId: string) => ["tenant-users", companyId] as const,
  },
  knowledge: {
    byCompany: (companyId: string) => ["knowledge", companyId] as const,
  },
  agentConversations: {
    byCompany: (companyId: string) => ["agent-conversations", companyId] as const,
    messages: (id: string) => ["agent-conversations", "messages", id] as const,
  },
  tenantGroups: {
    byCompany: (companyId: string) => ["tenant-groups", companyId] as const,
    members: (groupId: string) => ["tenant-groups", "members", groupId] as const,
  },
  agentAccess: {
    byAgent: (agentId: string) => ["agent-access", agentId] as const,
    accessible: (companyId: string) => ["agent-access", "accessible", companyId] as const,
  },
  agentMemoryAccess: {
    byAgent: (agentId: string) => ["agent-memory-access", agentId] as const,
  },
  entra: {
    users: (companyId: string) => ["entra", "users", companyId] as const,
    groups: (companyId: string) => ["entra", "groups", companyId] as const,
  },
  tenantUserMe: {
    byCompany: (companyId: string) => ["tenant-user-me", companyId] as const,
  },
  agentUpdates: {
    latestVersion: ["agent-updates", "latest-version"] as const,
    agents: ["agent-updates", "agents"] as const,
  },
  apps: {
    byCompany: (companyId: string) => ["apps", "company", companyId] as const,
    detail: (id: string) => ["apps", "detail", id] as const,
    deployments: (appId: string) => ["apps", "deployments", appId] as const,
  },
  appTemplates: {
    all: ["app-templates"] as const,
    detail: (id: string) => ["app-templates", "detail", id] as const,
  },
  agentTasks: {
    byCompany: (companyId: string) => ["agent-tasks", "company", companyId] as const,
    byAgent: (agentId: string) => ["agent-tasks", "agent", agentId] as const,
    detail: (id: string) => ["agent-tasks", "detail", id] as const,
    runs: (taskId: string) => ["agent-tasks", "runs", taskId] as const,
  },
  workflows: {
    byCompany: (companyId: string) => ["workflows", "company", companyId] as const,
    detail: (id: string) => ["workflows", "detail", id] as const,
    validate: (id: string) => ["workflows", "validate", id] as const,
    versions: (id: string) => ["workflows", "versions", id] as const,
  },
  workflowRuns: {
    byWorkflow: (workflowId: string) =>
      ["workflow-runs", "workflow", workflowId] as const,
    byAgent: (agentId: string) => ["workflow-runs", "agent", agentId] as const,
    detail: (id: string) => ["workflow-runs", "detail", id] as const,
  },
  workflowsByAgent: (agentId: string) =>
    ["workflows", "agent", agentId] as const,
  evals: {
    byTarget: (companyId: string, targetId: string) =>
      ["evals", "target", companyId, targetId] as const,
    detail: (companyId: string, reportId: string) =>
      ["evals", "detail", companyId, reportId] as const,
  },
};
